import { makeStyles } from '@material-ui/core/styles';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const lightTheme = {
  root: {
    '& small': {
      color: hexToRGBA(TextColors.dark, TextOpacities.light1),
    },
  },
};

const darkTheme = {
  root: {
    '& small': {
      color: hexToRGBA(TextColors.light, TextOpacities.dark1),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    breadcrumb: {
      marginBottom: muiTheme.spacing(2),
    },
    heading: {
      marginBottom: muiTheme.spacing(2),
      marginTop: '11px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    content: () => ({
      [muiTheme.breakpoints.up('md')]: {
        display: 'flex',
      },
    }),
    sidebar: {
      position: 'relative',
      display: 'none',
      marginTop: '6px',

      '&': {
        [muiTheme.breakpoints.up('md')]: {
          display: 'block',
          flex: '0 0 225px',
          marginRight: muiTheme.spacing(6.875),
        },
      },
    },
    results: {
      flex: 1,
    },
    sidebarCertified: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '& img': {
        height: '13px',
        width: 'auto',
        marginTop: '3px',
        marginBottom: '-1px',
      },
    },
    chipsCertified: {
      '&.light-theme': lightTheme.root,
      '&.dark-theme': darkTheme.root,
      '& img': {
        height: '13px',
        width: 'auto',
        marginTop: '3px',
        marginBottom: '-1px',
      },
    },
    tabFilter: {
      display: 'none',
      [muiTheme.breakpoints.down('sm')]: {
        display: 'block',
        marginLeft: muiTheme.spacing(-4),
        marginRight: muiTheme.spacing(-4),
        marginBottom: muiTheme.spacing(4),
        fontWeight: 'bold',
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
      },
    },
    searchBar: {
      animation: 'enter 250ms ease-out',
      marginBottom: muiTheme.spacing(3.5),
      [muiTheme.breakpoints.up('sm')]: {
        display: 'flex',
        alignItems: 'flex-end',
        alignContent: 'flex-end',
      },
    },
    searchBarLabel: {
      '&.MuiTypography-root': {
        flex: '1 1 50%',
        [muiTheme.breakpoints.down('sm')]: {
          marginBottom: muiTheme.spacing(1),
        },
      },
    },
    searchBarInput: {
      flex: '1 1 50%',
      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(1),
      },
      [muiTheme.breakpoints.up('md')]: {
        marginLeft: muiTheme.spacing(2),
        marginBottom: muiTheme.spacing(1),
      },
    },
    chips: {
      '& > *': {
        animation: 'enter 250ms ease-out',
      },

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(3),
      },
    },
  }),
  { name: 'GenMarketplace' },
);

export default useStyles;
